/** @jsxImportSource @emotion/react */

import { CSSObject } from '@emotion/react';
import { fonts } from '../../style/fonts';
import { colors } from '../../style/colors';
import {
  PRIVACY_POLICY_EFFECTIVE_DATE,
  PRIVACY_POLICY_INTRO,
  PRIVACY_POLICY_SECTIONS,
} from './privacyPolicyData';

const contentCss: CSSObject = {
  ...fonts.text,
  color: colors.black,
  '.effective-date': {
    ...fonts.smallLabel,
    color: colors.darkerGrey,
    marginBottom: 16,
  },
  '.intro-paragraph': {
    marginBottom: 12,
  },
  h3: {
    ...fonts.h2,
    color: colors.blue2,
    margin: '20px 0 8px',
  },
  p: {
    margin: '0 0 10px',
  },
  ul: {
    margin: '0 0 10px',
    paddingLeft: 20,
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },
  a: {
    color: colors.blue3,
  },
  '.legal-disclaimer': {
    ...fonts.mini,
    color: colors.darkerGrey,
    marginTop: 24,
    fontStyle: 'italic',
  },
};

export default function PrivacyPolicyContent() {
  return (
    <div css={contentCss}>
      <div className="effective-date">
        Effective date: {PRIVACY_POLICY_EFFECTIVE_DATE}
      </div>

      {PRIVACY_POLICY_INTRO.map((paragraph) => (
        <p key={paragraph.slice(0, 24)} className="intro-paragraph">
          {paragraph}
        </p>
      ))}

      {PRIVACY_POLICY_SECTIONS.map((section) => (
        <section key={section.heading}>
          <h3>{section.heading}</h3>
          {section.paragraphs?.map((paragraph) => (
            <p key={paragraph.slice(0, 24)}>{paragraph}</p>
          ))}
          {section.bullets && (
            <ul>
              {section.bullets.map((bullet) => (
                <li key={bullet.slice(0, 24)}>{bullet}</li>
              ))}
            </ul>
          )}
        </section>
      ))}
    </div>
  );
}
